module.exports = __webpack_public_path__ + "static/media/13a-01-HOME_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.9de18b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13a/13a-01-HOME_Tablas-&-camas-2013-273x176mm-oleo-sobre-revista-National-Geographic-y-madera.png
// module id = 126
// module chunks = 0